"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changePassword = changePassword;
exports.nNotice = nNotice;
exports.listNotice = listNotice;
exports.catNotice = catNotice;
exports.bcatNotice = bcatNotice;
exports.rmotice = rmotice;
exports.brmNotice = brmNotice;

var _request = _interopRequireDefault(require("@/utils/request"));

function changePassword(data) {
  return (0, _request.default)({
    url: '/notice/password',
    method: 'post',
    data: data
  });
}

function nNotice() {
  return (0, _request.default)({
    url: '/notice/nnotice',
    method: 'get'
  });
}

function listNotice(query) {
  return (0, _request.default)({
    url: '/notice/lsnotice',
    method: 'get',
    params: query
  });
}

function catNotice(data) {
  return (0, _request.default)({
    url: '/notice/catnotice',
    method: 'post',
    data: data
  });
}

function bcatNotice(data) {
  return (0, _request.default)({
    url: '/notice/bcatnotice',
    method: 'post',
    data: data
  });
}

function rmotice(data) {
  return (0, _request.default)({
    url: '/notice/rmnotice',
    method: 'post',
    data: data
  });
}

function brmNotice(data) {
  return (0, _request.default)({
    url: '/notice/brmnotice',
    method: 'post',
    data: data
  });
}